import type { StudentLectureDtoT } from '.'

export const PERIOD_OPTIONS: readonly { value: StudentLectureDtoT.DueAtType; label: string }[] = [
  { value: 'NONE', label: '설정안함' },
  { value: 'SEVEN_DAYS', label: '7일' },
  { value: 'THIRTY_DAYS', label: '30일' },
  { value: 'CUSTOM', label: '직접선택' },
]

export type PeriodValue = StudentLectureDtoT.DueAtType

export const ASSIGNMENT_STATUS_TEXT: Record<StudentLectureDtoT.AssignmentStatus, string> = {
  NOT_STARTED: '미학습',
  IN_PROGRESS: '학습중',
  COMPLETED: '학습완료',
  EXPIRED: '기간만료',
  IN_PROGRESS_EXPIRED: '학습중(기간만료)',
}
